import { Injectable, OnInit } from '@angular/core';
import { RequestService } from './request.service';
import { IIsExistedResponse } from '../models/response';


@Injectable()
export class EmailService implements OnInit {

    constructor(
        protected _requestService: RequestService
    ) {

    }

    ngOnInit() {

    }

    VerifyEmail(email: string) {
        //console.log("VerifyEmail Call" );
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/verifyEmail', { "email": email },
                (data: IIsExistedResponse) => {
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVER", content:error.statusText })
                },
                null,
                false,
                null)
        })
    }
    
    FindEmail(rowIdCustomer: string = "",email: string) {
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/findEmail', {"rowIdCustomer": rowIdCustomer, "email": email },
                (data: IIsExistedResponse) => {
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText });
                },
                null,
                false,
                null)
        })
    }
}


// WEBPACK FOOTER //
// ./src/app/theme/services/email.service.ts